var sb = require('@sb/util')
var flow = require('@subiz/flow')
var stor8 = require('@subiz/storage')
import api from './api.js'
var Realtime = require('@subiz/wsclient/index.js')
var cookie = require('cookie_js')
var tracking = require('./tracking.js')
cookie.defaults.path = '/'
cookie.expiresMultiplier = 60 * 60 * 24 // days
cookie.defaults.expires = 3650 // 10 year

var config = require('@sb/config')
var util = require('./util.js')

const MAX_CONVO = 30

const VIVNLang = () => import(/*webpackChunkName: "vi-VN" */ './VIVNLang.js')
const ENUSLang = () => import(/*webpackChunkName: "en-US" */ './ENUSLang.js')

const AlertMP3 = () => import(/*webpackChunkName: "alert-mp3" */ '../../assets/media/alert.mp3')
const AlertOGG = () => import(/*webpackChunkName: "alert-ogg" */ '../../assets/media/alert.ogg')
let alertSoundPromise = document.createElement('audio').canPlayType('audio/mpeg') ? AlertMP3() : AlertOGG()

const LoadMainCSS = () => import(/*webpackChunkName: "main-css" */ './css.js')
let promiseMainCSS = LoadMainCSS()

var cssStyleDiv = document.createElement('style')
document.head.appendChild(cssStyleDiv)
cssStyleDiv.type = 'text/css'
cssStyleDiv.id = 'subiz-style'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
let i18n = new VueI18n()

let pubsub = new sb.Pubsub()

let kv = new stor8.kv(new stor8.lsdb('sbz2020'), 'kv')
let realtime

let g_sync = {}
function isInsync(key) {
	return Date.now() - (g_sync[key] || 0) < 60000
}

function disconnect(key) {
	g_sync[key] = 0
}

function markSync(key) {
	g_sync[key] = Date.now()
}

let chain = new stor8.chain(new stor8.lsdb('cbz2020', true), 'ch')

class Store {
	i18n = i18n
	/* public properties */
	isPreview = false // is offline?

	new_visitor = true

	matchUser = () => {
		if (!isInsync('account')) setTimeout(() => this.reconnect(), 100)
		return kv.match('user')
	}

	matchSession = () => kv.match('session') || {}
	matchAccount = () => kv.match('account')

	// current device (browser info) for tracking purpose
	device = {}

	browserVisibility = 'visible'

	matchAgent = id => {
		let agentM = kv.match('agent') || {}
		if (id === '*') return agentM
		return agentM[id]
	}

	matchImpressionLogs = () => kv.match('impression_logs') || []

	matchAccountSetting = () => {
		if (!isInsync('account')) setTimeout(() => this.reconnect(), 100)
		return kv.match('account_setting') || {}
	}

	matchConvo = id => {
		if (!id) return

		if (id === '*') {
			if (!isInsync('account')) setTimeout(() => this.reconnect(), 100)
			return sb.filter(kv.all(), (value, k) => k.startsWith('convo_'))
		}

		if (!isInsync(id)) this.fetchConvo(id)
		return kv.match('convo_' + id)
	}

	fetchConvo = async cid => {
		await this.readyGate.entry()
		await this.reconnectGate.entry(undefined, true)

		// do nothing when account is synced
		if (isInsync(cid)) return this.reconnectGate.open()
		markSync(cid)

		let {body: convo, error} = await api.getConversation(cid)
		if (convo && !error) this._setConvo(convo)

		return this.reconnectGate.open()
	}

	listEvents = id => {
		if (!id || id === '*' || typeof id !== 'string') return
		if (!isInsync('events' + id)) {
			setTimeout(async () => {
				await this.readyGate.entry()
				await this.reconnectGate.entry(undefined, true)
				if (isInsync('events' + id)) return this.reconnectGate.open()
				markSync('events' + id)
				await chain.reload(id, listmessageapi)
				pubsub.publish('account')
				return this.reconnectGate.open()
			}, 10)
		}
		return chain.listM(id)
	}

	fetchMoreEvents = async convoid => {
		let {error} = await chain.fetchMore(convoid, 50, listmessageapi)
		pubsub.publish('account')
		return {error}
	}

	matchCampaign = () => kv.match('campaign') || {}

	readyGate = new sb.Gate()
	convoGate = new sb.Gate(true)
	reconnectGate = new sb.Gate(true)

	/* private properties */
	mask = '' // ok

	seenQueue = [] // convoid will be seen

	// last widget screen
	matchLastview = () => kv.match('lastview') || {}
	matchIsOpen = () => !!kv.match('isopen') // is widget currently open
	matchHasManuallyClosed = () => !!kv.match('hasManuallyClosed') // true if user has ever closed the widget
	matchClosePreviewAt = () => kv.match('close_preview_at') || 0

	sendPresence = sb.throttle(() => {
		if (this.isPreview) return
		if (sb.isUserBanned(store.matchUser())) return
		if (!this.mask || !sb.get(this.matchUser(), 'id')) return // store not init
		api.sendPresence(this.device, this.browserVisibility === 'visible' && document.hasFocus())
	}, 1000)
	now = () => Date.now() + timeDiff // millisecond on server
	_isinit = false
	async init(accid) {
		if (this._isinit) return // dont init twice
		this._isinit = true

		accid = (accid || '').trim()

		loopTime()

		window.addEventListener('blur', () => this.sendPresence())
		window.addEventListener('focus', () => this.sendPresence())

		util.onVisibilityChange(val => {
			this.browserVisibility = val
			this.sendPresence()
		})

		let mask = '' // try to find mask in cookie
		try {
			mask = cookie.get('__sbmask', '')
		} catch (e) {
			console.error(e)
		}

		let localstorageMask = kv.match('mask')
		if (localstorageMask) {
			if (mask) {
				// check mask integrity, mask in cookie should match mask in localstorate
				// trust cookie, remove localstorage
				if (mask !== localstorageMask) {
					kv.destroy()
					kv = new stor8.kv(new stor8.lsdb('sbz2020'), 'kv')
				}
			} else mask = localstorageMask
		}

		var userId = ''
		// invalid account (may be user has changed their injected code), must recreate user
		if (mask) {
			const parts = mask.split('@')
			if (parts[0] != accid) {
				mask = ''
				clearBrowserData()
			} else {
				userId = parts[1]
			}
		}

		let user = kv.match('user') || {}
		if (!mask || !user.id) {
			user = await api.createUser(accid)
			this.mask = user.mask
			user.account_id = accid // server may not return account id
		} else {
			this.new_visitor = false // for checking returning or new visitor
			this.mask = mask
			user.id = userId
			user.account_id = mask.split('@')[0]
		}
		kv.put('user', user)
		pubsub.publish('account')

		// set cookie forever
		cookie.set('__sbmask', this.mask)
		kv.put('mask', this.mask)

		this.device = tracking.getDeviceInfo()

		// periodically send seen
		const _seenInterval = setInterval(() => {
			// deduplicate
			this.seenQueue = [...new Set(this.seenQueue)]

			sb.map(this.seenQueue, id => {
				var events = this.listEvents(id)
				if (!events) return
				if (sb.size(events) === 0) return

				// find the last message send
				events = sb.filter(events, ev => ev.type === 'message_sent')
				var lastmsgsent = events[sb.size(events) - 1]
				if (!lastmsgsent) return

				let pongs = sb.get(lastmsgsent, 'data.message.pongs', [])
				var seen = sb.find(pongs, pong => pong.type === 'seen' && pong.member_id === user.id)

				if (seen) return
				var convoid = sb.convoOfEv(lastmsgsent)
				// fake a pong message from server
				this.onWs({
					id: 'evfff' + sb.randomString(36),
					account_id: user.account_id,
					created: new Date().getTime(),
					type: 'message_pong',
					by: {id: user.id, client_id: 'widget', type: 'user'},
					data: {
						message: {
							conversation_id: convoid,
							id: lastmsgsent.id,
							pongs: [{member_id: user.id, type: 'seen', created: new Date().getTime(), _fake: true}],
						},
					},
				})

				// ignore sending message
				if (lastmsgsent.id === sb.getMsgField(lastmsgsent, 'idempotency')) return

				// send seen
				api.markAsSeen(convoid, lastmsgsent.id)
			})

			this.seenQueue = []
		}, 5000)

		// try to get Google Analytics tracking id and client id by periodically checking it after an interval
		const _gaInterval = setInterval(function() {
			var dev = tracking.getDeviceInfo()
			if (!dev.ga_tracking_ids || !dev.ga_client_id) return
			clearInterval(_gaInterval)
			this.device = dev
		}, 2000)

		let oldaccsetting = this.matchAccountSetting()
		if (sb.size(oldaccsetting) === 0) await this.reconnect(true)
		else {
			this.reconnect(true) // use old data and resync in the background
			let MainCSS = (await promiseMainCSS).default
			let outcss = util.replaceCssVariable(MainCSS, oldaccsetting)
			this.setCss(outcss)
			this.setLanguage(oldaccsetting.language, oldaccsetting.custom_language_url)
		}
		this.readyGate.open()

		// load alert sound
		try {
			const sound = new window.Audio()
			sound.src = (await alertSoundPromise).default
		} catch (e) {
			console.log('SOUND ERR', e)
		}

		realtime = new Realtime(config.RealtimeURL, {user_mask: this.mask})
		realtime.onEvent(this.onWs.bind(this))
		realtime.onInterrupted(() => this.reconnectWs())
		this.reconnectWs()

		setInterval(() => this.sendPresence(), 25 * 1000) // dont bother delete this
	}

	async reconnectWs() {
		let user = kv.match('user') || {}
		await realtime.subscribe([
			`conversation_state_updated.account.${user.account_id}.user.${user.id}`,
			`conversation_joined.account.${user.account_id}.user.${user.id}`,
			`conversation_left.account.${user.account_id}.user.${user.id}`,
			`conversation_typing.account.${user.account_id}.user.${user.id}`,
			`message_sent.account.${user.account_id}.user.${user.id}`,
			`conversation_pending.account.${user.account_id}.user.${user.id}`,
			`user_info_updated.account.${user.account_id}.user.${user.id}`,
			`message_pong.account.${user.account_id}.user.${user.id}`,
			`conversation_rating_requested.account.${user.account_id}.user.${user.id}`,
			`conversation_rated.account.${user.account_id}.user.${user.id}`,
		])
		disconnect('account')
		await this.reconnect()
	}

	// stupid is a very stupid variable, we should remove it
	async reconnect(stupid) {
		if (this.isPreview) return
		// make sure we only run reconnect once in a time

		if (!stupid) await this.readyGate.entry()
		await this.reconnectGate.entry(undefined, true)
		// do nothing when account is synced
		if (isInsync('account')) return this.reconnectGate.open()
		markSync('account')

		await Promise.all([
			(async () => {
				let {body: userSetting, error} = await api.getUserSetting()
				if (error) return
				return this._setSetting(userSetting)
			})(),
			(async () => {
				// refetch convo
				let {body: result, error} = await api.listConversations()
				if (!error) {
					let convos = sb.get(result, 'conversations', [])
					// clear all old convo
					sb.map(kv.all(), (value, k) => {
						if (k.startsWith('convo_')) kv.del(k)
					})
					sb.map(convos, convo => this._setConvo(convo))
				}
			})(),
		])

		return this.reconnectGate.open()
	}

	// turn previewing mode on, widget is now just for demo
	// we created previewing mode to display widget inside the dashboard
	preview() {
		this.isPreview = true
	}

	// set user info, keeping old user id and account id
	async setUser(user) {
		if (!user) return
		await this.readyGate.entry()
		if (this.isPreview) return
		this._setUser(user)
		return api.updateUser(user)
	}

	_setUser(user) {
		let olduser = kv.match('user') || {}
		var oldAccid = olduser.account_id
		var oldId = olduser.id

		// merge attr
		sb.each(user.attributes, newattr => {
			if (!newattr) return
			olduser.attributes = sb.filter(olduser.attributes, oldattr => {
				if (!oldattr) return false
				return oldattr.key !== newattr.key
			})
		})
		olduser.attributes = olduser.attributes || []
		olduser.attributes = olduser.attributes.concat(user.attributes)
		olduser.account_id = oldAccid
		olduser.id = oldId

		kv.put('user', olduser)
		pubsub.publish('account')
	}

	setCss(css) {
		if (cssStyleDiv.styleSheet) {
			// This is required for IE8 and below.
			cssStyleDiv.styleSheet.cssText = css
		} else {
			cssStyleDiv.innerHTML = ''
			cssStyleDiv.appendChild(document.createTextNode(css))
		}
	}

	async setSetting(setting) {
		if (!setting) return
		await this.readyGate.entry()
		return this._setSetting(setting)
	}

	async _setSetting(setting) {
		setting = sb.cloneDeep(setting)
		util.fixMissingSetting(setting)

		// user && session
		if (setting.user) {
			let oldsession = this.matchSession()
			let session = setting.user.session
			if (session) {
				if (session.id === oldsession.id) {
					// refresh session, but keep old local fields
					session._urls = oldsession._urls
				} else {
					// session changed, clear all old data
				}
			} else {
				// dont change session
				session = oldsession
			}

			session._urls = session._urls || []
			session._urls.push(location.href)
			while (session._urls.length > 1000) session._urls.shift()

			kv.put('session', session)

			delete setting.user.session
			this._setUser(setting.user)
		}

		// account
		if (setting.account) {
			kv.put('account', setting.account)
			delete setting.account
		}

		// campaign
		let campaigns = sb.get(setting, 'campaigns', [])
		let campaignM = {}
		sb.map(campaigns, cam => {
			campaignM[cam.id] = cam
		})
		kv.put('campaign', campaignM)

		// agent & account setting
		if (setting.account_setting) {
			var agents = setting.account_setting.agents || []
			if (agents.length > 0) {
				let agentM = {}
				sb.map(agents, agent => {
					agentM[agent.id] = agent
				})
				kv.put('agent', agentM)
				delete setting.account_setting.agents
			}

			let MainCSS = (await promiseMainCSS).default
			let outcss = util.replaceCssVariable(MainCSS, setting.account_setting)
			this.setCss(outcss)

			let oldAccSetting = this.matchAccountSetting()
			this.setLanguage(oldAccSetting.language, setting.account_setting.custom_language_url)
			kv.put('account_setting', setting.account_setting)
		}
		markSync('account')
		pubsub.publish('account')
	}

	// change current language setting
	// accLangCode: en-US || vi-VN
	async setLanguage(accLangCode, custom_language_url, customLangData) {
		var langCode = accLangCode || ''
		if (!sb.isValidLanguageCode(langCode)) langCode = navigator.language

		// download base lang
		var deflangpofunc = langCode === 'vi-VN' || langCode === 'vi' ? VIVNLang : ENUSLang
		var poFile = sb.get(await deflangpofunc(), 'default.translations', {})
		let lang = {}
		sb.map(poFile, messageObject => {
			let obj = sb.get(messageObject, [Object.keys(messageObject)[0]], {})
			lang[sb.trimStart(obj.msgctxt, '.')] = obj.msgstr[0]
		})

		const customLangURL = sb.replaceFileUrl(custom_language_url)
		// only use custom language if the current language matched predefined lang code in account setting
		customLangData = customLangData || {}

		if (customLangURL && accLangCode === langCode) {
			const {body: customLangFromUrl} = await api.ajax.get(customLangURL)
			customLangData = Object.assign({}, customLangFromUrl, customLangData)
		}

		lang = Object.assign({}, lang, customLangData)
		i18n.setLocaleMessage(langCode, lang)
		i18n.locale = langCode
	}

	// send the content view, the first presence and record domain
	async track() {
		if (this.isPreview) return
		let user = kv.match('user') || {}
		await api.sendContent(this.device, location.href, document.title)
		this.sendPresence()
	}

	async onWs(ev) {
		if (!ev || !ev.type) return
		ev.created = sb.getMs(ev.created)
		let user = kv.match('user') || {}
		const INTEGRATION_ID = sb.getIntegrationId(user.account_id)

		let cid = sb.convoOfEv(ev)
		let convo
		if (cid) {
			convo = this.matchConvo(cid)
			if (!convo || !convo.id) {
				let {body: apiconvo, error} = await api.getConversation(cid)
				if (!apiconvo) return
				convo = apiconvo
			}
			// ignore wrong integration
			let integrationId = sb.get(convo, 'integration.id', '')
			if (!integrationId) integrationId = sb.get(ev, 'data.message.integration_id', '')
			if (!integrationId || integrationId !== INTEGRATION_ID) return
			pubsub.publish('events', ev)
		}

		// server doesn't send events before conversation_joined occur
		// so re-get events of this conversation to ensure we dont miss any event
		if (ev.type === 'conversation_joined') {
			let members = sb.get(ev, 'data.conversation.members', [])
			let me = sb.find(members, m => m.id === kv.match('user').id)
			if (me) {
				await chain.reload(cid, listmessageapi)
				markSync('events' + cid)
				pubsub.publish('account')
			}
		}

		// ignore if event come from another integration
		if (sb.startsWith(ev.type, 'message_') || sb.startsWith(ev.type, 'conversation_')) {
			this.restConvoEvent(ev)
			if (ev.type === 'message_sent' && sb.get(ev, 'by.id') !== user.id) {
				tracking.sendEventToThirdParty('SUBIZ Chat', 'Received', 'User')
			}
			return
		}

		if (ev.type === 'user_info_updated') {
			let user = sb.cloneDeep(kv.match('user'))
			let attrs = sb.get(ev, 'data.user.attributes') || []
			sb.map(attrs, attr => sb.setUserAttr(user, attr))
			this._setUser(user)
			return
		}
	}

	async restConvoEvent(ev) {
		let user = kv.match('user')
		sb.backwardCompatibleEv(ev, user)

		let cid = sb.convoOfEv(ev)
		let convo = kv.match('convo_' + cid) || {}
		if (ev.type === 'conversation_state_updated') {
			if (!sb.get(convo, 'id')) {
				let {body: convo, error} = await api.getConversation(convo.id)
				if (error) return
			}
			convo = Object.assign(convo, sb.get(ev, 'data.conversation'))
			this._setConvo(convo)
		}

		if (ev.type === 'message_pong') {
			// update pongged message
			var msgid = sb.get(ev, 'data.message.id')
			var oldev = chain.match(cid, msgid)

			if (!sb.get(oldev, 'data.message')) return

			var pongs = sb.get(oldev, 'data.message.pongs', [])
			pongs = pongs.concat(sb.get(ev, 'data.message.pongs', []))
			oldev.data.message.pongs = pongs
			chain.put(cid, oldev.id, sb.getMs(oldev.created), oldev)
		}

		if (ev.type === 'message_sent') {
			let idemkey = sb.getMsgField(ev, 'idempotency')
			let found = sb.find(this.listEvents(cid), oldev => {
				return oldev.id === idemkey
			})
			if (found) {
				// keeping old created so the ui can be static
				chain.del(cid, found.id)
				ev.created = found.created
			}

			convo.last_message = sb.get(ev, 'data.message', {})
			convo.last_message_id = ev.id
			this._setConvo(convo)
			// this.handleFormSubmit(convoKey, ev)
		}

		// dont store pong and typing
		if (ev.type !== 'message_pong' && ev.type !== 'conversation_typing') {
			chain.put(cid, ev.id, sb.getMs(ev.created), ev)
		}
		pubsub.publish('account')
	}

	handleFormSubmit(convoKey, ev) {
		// find form submit
		if (ev.type !== 'message_sent') return
		// has form submit
		let formSubmits = []
		let attachments = sb.get(ev, 'data.message.attachments') || []
		sb.each(attachments, att => {
			if (!att) return
			if (att.type !== 'form_submit') return
			formSubmits.push(att.form_submit)
		})

		sb.each(formSubmits, submit => {
			let formev = sb.get(this.convoEventM, convoKey + '.' + submit.form_message_id)
			if (!formev) return

			// find form attachment
			let forms = sb.filter(sb.get(formev, 'data.message.attachments'), att => {
				if (!att) return false
				if (att.type !== 'form' && att.type !== 'ask_info_form') return false
				return true
			})

			sb.each(forms, form => {
				form = form.form
				form._submitted = true
				sb.each(form.fields, formfield => {
					sb.each(submit.fields, submitfield => {
						if (formfield.name !== submitfield.name) return
						if (formfield.default_answer) return

						formfield.default_answer = submitfield.value
					})
				})
			})

			if (sb.size(forms) > 0) pubsub.publish('state.convoEventM', this.convoEventM, convoKey)
		})
	}

	typing(cid) {
		if (!cid) return
		if (this.isPreview) return
		this._typing(cid)
	}

	_typing = sb.throttle(convoid => api.sendTyping(convoid), 3000)

	async startConvo(req) {
		if (this.isPreview) return
		this.convoGate.close()
		let {body: convo, error} = await api.start(req)
		this.convoGate.open()

		if (error) return {error}
		this._setConvo(convo)
		return {convo}
	}

	async sendConvoEvent(cid, type, data) {
		if (this.isPreview) return
		var idempotency = sb.randomString(36)

		let user = kv.match('user') || {}
		var event = {
			id: idempotency,
			by: {id: user.id, type: 'user'},
			data,
			type,
			created: this.now(),
		}
		sb.convoToEv(cid, event)
		let files = []
		if (type === 'message_sent') {
			sb.setMsgField(event, 'idempotency', idempotency)
			event.data.message.conversation_id = cid

			// pre upload image files
			await flow.map(event.data.message.attachments, 2, async (att, i) => {
				if (att.type !== 'file') return
				if (!att._file) return
				files.push(att)
				if (ImageTypes.includes(att._file.type)) {
					att.url = await loadImage(att._file)
				}
			})
		}

		this.onWs(event) // display sending
		await this.convoGate.entry()
		// upload file first

		await flow.map(files, 1, async att => {
			const {url, error} = await api.uploadToS3(att._file)
			event._error = error
			att.url = url
		})

		if (event._error) return this.onWs(event) // dont send error msg
		let {body: ret, error} = await api.sendConvoEvent(cid, event)
		if (error) {
			event._error = error
			this.onWs(event)
			return
		}
		this.onWs(ret)
		tracking.sendEventToThirdParty('SUBIZ Chat', 'Sent', 'User')
	}

	onTime = cb => pubsub.on('time', cb)
	un = subid => pubsub.un(subid)

	onConvoEvent(vue, cb) {
		var sub = pubsub.on('events', cb)
		vue.$once('hook:beforeDestroy', () => pubsub.un(sub))
		return sub
	}

	seenConvo = (id, ev) => {
		if (!ev || ev.type !== 'message_sent') return
		if (!id || id === 'create') return
		this.seenQueue.push(id)
	}

	_setConvo(convo) {
		let count = 0

		// ignore invalid conversation
		let user = kv.match('user')
		const INTEGRATION_ID = sb.getIntegrationId(user.account_id)
		let integrationId = sb.get(convo, 'integration.id', '')
		if (!integrationId || integrationId !== INTEGRATION_ID) return

		let allconvo = {}
		// trim
		sb.map(kv.all(), (value, key) => {
			if (key.startsWith('convo_')) {
				allconvo[key] = value
			}
		})

		if (sb.size(allconvo) > MAX_CONVO - 2) {
			// remove
			allconvo = sb.orderBy(sb.map(allconvo), 'created', 'desc')
			for (var i = MAX_CONVO - 2; i < sb.size(allconvo); i++) {
				let convo = allconvo[i]
				kv.del('convo_' + convo.id)
			}
		}

		markSync(convo.id)
		pubsub.publish('account')
		kv.put('convo_' + convo.id, convo)
	}

	onUpdate = (o, cb) => pubsub.on2(o, 'account', cb)

	setHasManuallyClosed = () => kv.put('hasManuallyClosed', true)
	setIsOpen = isopen => {
		let lastisopen = kv.match('isopen')
		kv.put('isopen', isopen)
		if (!lastisopen && isopen) tracking.sendEventToThirdParty('SUBIZ Chat', 'Opened', 'Subiz Windows')
	}
	closePreview = () => kv.put('close_preview_at', new Date().getTime())
	setLastview = (view, opts) => kv.put('lastview', {view, opts})

	sendImpression(campid, triggerType) {
		let user = kv.match('user') || {}
		let logs = kv.match('impression_logs') || []
		while (sb.size(logs) > 200) logs.shift()
		logs.push({id: campid, created: this.now()})
		kv.put('impression_logs', logs)

		return api.sendImpression({
			account_id: user.account_id,
			campaign_id: campid,
			user_id: user.id,
			url: window.location.href,
			device: this.device,
			by_trigger: triggerType,
		})
	}

	sendConversion(campid, triggerType, submission, impressionToken) {
		let user = kv.match('user') || {}
		return api.sendConversion({
			account_id: user.account_id,
			campaign_id: campid,
			user_id: sb.get(user, 'id'),
			url: window.location.href,
			device: this.device,
			by_trigger: triggerType,
			submission,
			impression_token: impressionToken,
		})
	}

	setGoalReached(campid) {
		let user = kv.match('user') || {}
		return api.setGoalReached({
			account_id: user.account_id,
			campaign_id: campid,
			user_id: user.id,
			status: 'goal_reached',
		})
	}
}

function clearBrowserData() {
	const cookies = cookie.all() || {}
	sb.each(cookies, (v, k) => {
		if ((k || '').startsWith('__sb')) cookie.remove(k)
	})
	kv.destroy()
	kv = new stor8.kv(new stor8.lsdb('sbz2020'), 'kv')
}

var store = new Store()
api.setStore(store)

async function listmessageapi(type, anchor, limit) {
	let convoid = type
	let {body: events, code, error} = await api.listMessages(convoid, -limit, anchor)
	if (error || code !== 200) return [[], anchor, error]
	anchor = sb.get(sb.last(events), 'id')

	events = sb.map(events, event => {
		event.created = sb.getMs(event.created)
		return {id: event.id, index: event.created, value: event}
	})
	return [events, anchor]
}

// expose store for debugging purpose
window.sbz_store = store

export default store

/* TODO: test ban user
	onApiError(code) {
	if (
	!(
	code === 'wrong_account_in_credential' ||
	code === 'account_not_found' ||
	code === 'invalid_credential' ||
	code === 'wrong_user_in_credential' ||
	code === 'user_not_found' ||
	code === 'invalid_mask' ||
	code === 'user_is_blocked' ||
	code === 'domain_is_not_whitelisted'
	)
	) {
	return
	}

	if (code !== 'user_is_blocked' && code !== 'domain_is_not_whitelisted') {
	let user = this.matchUser()
	sb.setUserAttr(user, {key: 'is_ban', boolean: true})
	kv.put('user', user)
	pubsub.publish('account')
	return
	}
	}
*/

/*

lo.map(offlineActionKV.all(), offlineEv => {
	// delete too old msg
	if (sb.now() - offlineEv.created > 86400000) {
		offlineActionKV.del(offlineEv.id) // ignore
		return
	}
	if (sb.convoOfEv(offlineEv) !== convoid) return

	let found = lo.find(msgM, ev => {
		let idemkey = sb.getMsgField(ev, 'idempotency')
		// message send success
		return offlineEv.id === idemkey
	})

	if (found) {
		// delete after 1 min
		if (sb.now() - offlineEv.created > 60000) {
			offlineActionKV.del(offlineEv.id) // ignore
			return
		}

		// keeping the old created so the ui can be static a litle bit
		let newev = Object.assign({}, found)
		newev.created = offlineEv.created
		msgM[found.id] = newev
		// offlineActionKV.del(idemkey) // ignore
		return
	}

	// item haven't been sent
	msgM[offlineEv.id] = offlineEv
})

*/

function loadImage(file) {
	return new Promise(rs => {
		var reader = new window.FileReader()
		reader.onload = e => {
			// after load all img data into the RAM, find update the corresponse attachment
			// since the attachment is very deep, we must force rerender
			rs(e.target.result) // url
		}
		reader.readAsDataURL(file)
	})
}

const ImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/svg+xml']

var timeDiff = 0
async function loopTime() {
	let startms = Date.now()
	let {body: t, error} = await api.time()
	var latences = Math.abs(Date.now() - startms) / 2
	var serverMs = new Date(t).getTime() + latences
	var localMs = Date.now()
	timeDiff = Math.floor(serverMs - localMs)
	setTimeout(loopTime, 30000)
}
